<template>
  <div class="mc-delivery-banner">
    <i class="mc-delivery-banner__icon icon-outline_alert-triangle"></i>
    <div class="mc-delivery-banner__text">
      {{message}}
    </div>
  </div>
</template>

<script>
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    actionHandlers: {
      type: Object,
    },
    message: {
      type: String,
    }
  },
}
</script>

<style lang="scss" scoped>
.mc-delivery-banner {
  width: 100%;
  height: 72px;
  background-color: #fff3e6;
  font-size: 13px;
  padding: 0px 20px;
  margin-top: -24px;
  margin-bottom: 12px;

  display: flex;
  align-items: center;
  gap: 40px;

  .mc-delivery-banner__text {
    height: fit-content;
  }

  .mc-delivery-banner__icon:before {
    color: #ff8a00;
    font-size: 32px;
  }
}
</style>
